import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useAppSelector } from "../hooks";

const authInitialState: Auth = {
  username: "",
  token: {
    accessToken: "",
    expiresIn: 0,
    tokenType: "",
    scope: "",
  },
};

const authSlice = createSlice({
  name: "auth",
  initialState: authInitialState,
  reducers: {
    // The access token is kept in memory only. The refresh token is never held in
    // JS state — it lives exclusively in a secure httpOnly cookie managed by the API.
    setCredentials: (state, action: PayloadAction<Auth>) => {
      state.username = action.payload.username;
      state.token = action.payload.token;
    },
    setToken: (state, action: PayloadAction<Token>) => {
      state.token = action.payload;
    },
    logout: () => authInitialState,
  },
});

export const { setCredentials, setToken, logout } = authSlice.actions;

export default authSlice.reducer;

/**
 * Maps a raw auth API LoginResponse (snake_case) to the in-memory Token shape.
 * The refresh token is intentionally omitted — it lives only in the httpOnly cookie.
 */
export const toToken = (response: LoginResponse): Token => ({
  accessToken: response.access_token,
  expiresIn: response.expires_in,
  tokenType: response.token_type,
  scope: response.scope,
});

export const useCurrentAuthenticatedUser = () =>
  useAppSelector((state) => state.auth);
